import FormSuccessPage from 'routes/ReferralForm/FormView/components/FormSuccessPage/FormSuccessPage';

export default FormSuccessPage;
